<template>
  <v-card class="elevation-5 mb-4 px-5 py-3">
    <v-layout align-center justify-start row wrap>
      <h1
        class="font-weight-black mr-4 primary--text subheading"
        :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
      >
        Filtrar período
      </h1>
      <v-flex xs12 sm3 md2>
        <v-menu
          full-width
          lazy
          offset-y
          max-width="290px"
          min-width="290px"
          transition="scale-transition"
          v-model="competenciaInicioPicker"
          :close-on-content-click="false"
          :nudge-right="40"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              persistent-hint
              readonly
              label="Competência Inicio"
              prepend-icon="event"
              v-model="competenciaInicioFormatted"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            no-title
            locale="pt-br"
            type="month"
            v-model="competenciaInicio"
            @change="atualizaCompetencias"
            @input="competenciaInicioPicker = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm3 md2>
        <v-menu
          full-width
          lazy
          offset-y
          max-width="290px"
          min-width="290px"
          transition="scale-transition"
          v-model="competenciaFimPicker"
          :close-on-content-click="false"
          :nudge-right="40"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              persistent-hint
              readonly
              label="Competência Fim"
              prepend-icon="event"
              v-model="competenciaFimFormatted"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            no-title
            locale="pt-br"
            type="month"
            v-model="competenciaFim"
            @change="atualizaCompetencias"
            @input="competenciaFimPicker = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>
  </v-card>
</template>

<script>
import moment from "moment";

export default {
  name: "ExtratoDespesaFiltro",
  props: {
    competenciasFiltro: Object
  },
  data() {
    return {
      competenciaInicio: this.competenciasFiltro.inicio,
      competenciaInicioPicker: false,
      competenciaFim: this.competenciasFiltro.fim,
      competenciaFimPicker: false
    };
  },
  computed: {
    competenciaInicioFormatted() {
      return moment(this.competenciaInicio, "YYYY-MM").format("MM/YYYY");
    },
    competenciaFimFormatted() {
      return moment(this.competenciaFim, "YYYY-MM").format("MM/YYYY");
    }
  },
  methods: {
    atualizaCompetencias() {
      this.$emit("update-competencias", {
        inicio: this.competenciaInicio,
        fim: this.competenciaFim
      });
    }
  }
};
</script>
